"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPassportValues = void 0;
const getPassportValues = (input) => {
    const parts = input.split(' ');
    const series = parts[0] + parts[1];
    const number = parts[2];
    return [series, number];
};
exports.getPassportValues = getPassportValues;
